module.exports = __webpack_public_path__ + "media/images/app/colors/colors-purple-ea80b5960daf66cc736dfb2640e3ddef.webp";